import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { actionGetBlogBySlug, actionGetRelatedBlogs } from 'store/actions';

import { ReactComponent as ToLink } from 'assets/icons/ToLink.svg';
import { ReactComponent as Share } from 'assets/icons/Share.svg';
import { ReactComponent as Fb } from 'assets/icons/Fb.svg';
import { ReactComponent as Twitter } from 'assets/icons/Twitter.svg';

import SmallCard from 'components/SmallCard/SmallCard';

import styles from './index.module.scss';

function BlogDetailsPage() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const selectedLanguage = localStorage.getItem('selectedLanguage');

  const data = useSelector((state) => state.Blog);
  const relatedBlogs = useSelector((state) => state.Blogs.relatedBlogs);

  const [notificationVisible, setNotificationVisible] = useState(false);

  const showNotification = () => {
    setNotificationVisible(true);

    setTimeout(() => {
      setNotificationVisible(false);
    }, 2000);
  };

  const copyCurrentUrl = () => {
    const currentUrl = window.location.href;
    const textarea = document.createElement('textarea');
    textarea.value = currentUrl;
    document.body.appendChild(textarea);

    textarea.select();
    document.execCommand('copy');

    document.body.removeChild(textarea);
  };

  const createFacebookPost = () => {
    const currentUrl = encodeURI(window.location.href);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;

    window.open(facebookShareUrl, '_blank');
  };

  const createTwitterPost = () => {
    const currentUrl = encodeURI(window.location.href);
    const twitterShareUrl = `https://twitter.com/intent/tweet?url=${currentUrl}`;

    window.open(twitterShareUrl, '_blank');
  };

  const formatDate = (dateString) => {
    const options = { month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const parsedHTML = new DOMParser().parseFromString(data.blog?.content?.html, 'text/html');

  useEffect(() => {
    dispatch(actionGetBlogBySlug({ slug: id }));
    dispatch(actionGetRelatedBlogs({ tags: ['Scam', 'Fraud'] }));
  }, [selectedLanguage]);

  return (
    <div>
      <div className={styles.Container}>
        <div className={`${styles.InnerContainer} ${data.blog?.isHighlight ? styles.Highlight : ''}`}>
          {data.blog?.isHighlight
            ? (
              <img
                src={data.blog.coverImage.url}
                alt={data.blog.slug}
                className={styles.HighlightImage}
              />
            )
            : ''}

          <div className={styles.ShareWrapper}>
            <div className={styles.ShareContainer}>
              <Share onClick={() => { copyCurrentUrl(); showNotification(); }} />
              <Fb onClick={createFacebookPost} />
              <Twitter onClick={createTwitterPost} />

              <div className={`${styles.Notification} ${notificationVisible ? styles.Active : ''}`}>
                URL Copied!
              </div>
            </div>
          </div>

          {data.blog && data.blog.content ? (
            <div className={styles.BlogContainer}>
              <Link to="/blog" className={styles.BackButton}>
                <ToLink />
                {t('TRỞ VỀ')}
              </Link>

              <div className={styles.Title}>{data.blog.title}</div>

              <div className={styles.Subtitle}>
                {formatDate(data.blog.date)}
                ,
                by
                {' '}
                {data.blog.author?.name ? (
                  <span>{data.blog.author.name}</span>
                ) : (
                  <span>Anonymous</span>
                )}
              </div>

              {data.blog.isHighlight
                ? ''
                : <img src={data.blog.coverImage.url} alt={data.blog.slug} />}

              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: parsedHTML.documentElement.outerHTML }}
                className={styles.Content}
              />
            </div>
          ) : <div className={styles.EmptyBlog} />}

          <div className={styles.RightContainer}>
            <div className={styles.ReadMore}>
              {t('Đọc thêm')}
            </div>

            <div className={styles.TopCardContainer}>
              {relatedBlogs.length
                ? relatedBlogs.map((post) => (
                  <Link to={`/blog/${post.slug}`} key={post.slug} className={styles.ToBlog}>
                    <SmallCard
                      image={post.coverImage.url}
                      title={post.title}
                    />
                  </Link>
                )) : <div className={styles.Card} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogDetailsPage;
